import { render, staticRenderFns } from "./HomeProject.vue?vue&type=template&id=6934b9ac&scoped=true"
import script from "./HomeProject.vue?vue&type=script&lang=js"
export * from "./HomeProject.vue?vue&type=script&lang=js"
import style0 from "./HomeProject.vue?vue&type=style&index=0&id=6934b9ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6934b9ac",
  null
  
)

export default component.exports